import React from 'react';
import { motion } from 'framer-motion';
import { FiMessageSquare, FiZap, FiArrowRight } from 'react-icons/fi';

export default function SmallQuickAction({ data, color }) {
    // 🛡️ BLINDAGEM DE DADOS (API Real + Mock)
    const title = data?.titulo || data?.title || 'Ativo Sniper';
    const ref = data?._id?.slice(-4).toUpperCase() || data?.id || '7702';

    return (
        <motion.div 
            whileHover={{ scale: 1.02, x: 5 }}
            className="flex items-center justify-between p-2 pl-8 rounded-full border transition-all duration-500 group shadow-lg hover:shadow-2xl"
            style={{ 
                backgroundColor: 'var(--bg-card)', 
                borderColor: 'var(--border-color)' 
            }}
        >
            {/* 📄 LABEL TÁTICA */}
            <div className="flex flex-col min-w-0">
                <div className="flex items-center gap-2">
                    <div className="w-1 h-1 rounded-full animate-pulse" style={{ backgroundColor: color || 'var(--accent-color)' }} />
                    <span className="text-[8px] font-black uppercase tracking-[0.3em] opacity-30 text-auto">Action Trigger</span>
                </div>
                <h4 className="text-[11px] font-black uppercase tracking-tighter text-auto truncate pr-4"
                    style={{ color: 'var(--text-primary)' }}>
                    {title} <span className="opacity-20 ml-2">#{ref}</span>
                </h4>
            </div>

            {/* ⚡ BOTÃO DE COMANDO */}
            <div className="flex items-center gap-2">
                {/* Status HUD Interno (Aparece no Hover) */}
                <div className="hidden md:flex flex-col items-end opacity-0 group-hover:opacity-100 transition-all duration-500 translate-x-4 group-hover:translate-x-0">
                    <span className="text-[7px] font-black uppercase text-accent tracking-widest" style={{ color }}>Online</span>
                    <span className="text-[7px] font-bold text-auto opacity-30 uppercase">Sincronizado</span>
                </div>

                <button 
                    className="relative w-14 h-14 rounded-full flex items-center justify-center text-white shadow-xl transition-all duration-300 group-hover:rotate-[360deg]"
                    style={{ backgroundColor: color || 'var(--accent-color)' }}
                >
                    <div className="absolute inset-0 rounded-full animate-ping opacity-20" style={{ backgroundColor: color || 'var(--accent-color)' }} />
                    <FiMessageSquare size={20} className="relative z-10" />
                    
                    {/* Indicador de Seta Stealth */}
                    <div className="absolute -right-1 opacity-0 group-hover:opacity-100 group-hover:right-[-20px] transition-all duration-500">
                        <FiArrowRight size={14} style={{ color }} />
                    </div>
                </button>
            </div>

            {/* Linha de Progresso Invisível (Border Bottom Glow) */}
            <div className="absolute bottom-0 left-1/4 right-1/4 h-[1px] opacity-0 group-hover:opacity-100 transition-opacity"
                 style={{ background: `linear-gradient(90deg, transparent, ${color}, transparent)` }} />
        </motion.div>
    );
}